/* tslint:disable */
/* eslint-disable */
export enum WorkProjectSystemTypesEnum {
  Neu = 'Neu',
  Erweiterung = 'Erweiterung'
}
